import { useNavigate } from "react-router-dom";
import { FETCH_LIST_ITEMS as fetchListItems } from "../../../../../graphql/query/ListItems";
import { SelectList, multiSelect } from "../../../../../components/Functional";
import ExportImages from "./ExportImages";
import { LIST_TYPES } from "../../../../../constants/listTypes";

const Actions = props => {
  const { formik, imageListId, imageWorkingListId } = props || {};
  const navigate = useNavigate();
  const listId = imageListId || imageWorkingListId;
  const ids = Object.keys(formik?.values?.selectedImages?.ids || {})?.map(
    item => parseInt(item.replace("_", "")),
  );

  return (
    <div className="flex flex-wrap gap-2 sm:gap-4">
      <SelectList.RemoveSelected {...props} ids={ids} listId={listId} />
      <SelectList.ClearList {...props} listId={listId} />
      <SelectList.CopyList
        {...props}
        listId={imageListId || imageWorkingListId}
        typeId={LIST_TYPES.ARTWORK_IMAGE}
        sourceTypeId={LIST_TYPES.ARTWORK_IMAGE}
        onSuccess={() => (
          props?.onSuccess?.(),
          navigate("/artworks?status=selectListWorking")
        )}
      />
      <ExportImages {...props} ids={ids} listId={listId} />
      {imageListId ? (
        <SelectList.ExitEditMode
          onSuccess={() => (
            props?.onSuccess?.(),
            navigate("/artworks?status=imageSelectListSaved")
          )}
        />
      ) : (
        <SelectList.SaveList
          {...{
            ...props,
            typeId: LIST_TYPES.ARTWORK_IMAGE,
            onSuccess: () => (
              props?.onSuccess?.(),
              navigate("/artworks?status=imageSelectListSaved")
            ),
            workingListId: imageWorkingListId,
          }}
        />
      )}
    </div>
  );
};

const tableProps = props => {
  const { imageListId, imageWorkingListId, formik } = props || {};
  // Prioritize imageListId (saved image list) over imageWorkingListId (working image list)
  const finalListId = imageListId || imageWorkingListId;

  const multiSelectProps = {
    formik,
    label: "Instances",
    name: "selectedImages",
    keyName: "id",
  };

  const tableProps = {
    dataKey: "listItems",
    fetchPolicy: "network-only",
    FETCH_QUERY: fetchListItems({
      item: { artwork: { title: true, artists: { name: true } }, imgT: true, imgX: true },
    }),
    headers: [
      multiSelect(multiSelectProps),
      { label: "Artwork Image", name: "item.imgT", type: "image" },
      { label: "Artwork Name", name: "item.artwork.title", type: "label" },
      {
        label: "Artist Name",
        name: "item.artwork.artists[0].name",
        type: "label",
      },
    ],
    skip: () => !finalListId,
    variables: {
      listId: finalListId,
    },
  };

  return tableProps;
};

export { Actions, tableProps };
